<!-- =========================================================================================
  File Name: ResetUserPasswordSidebar.vue
  Description: Add New Data - Sidebar component
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <vs-sidebar click-not-close position-right parent="body" default-index="1" color="primary" class="add-new-data-sidebar items-no-padding" spacer v-model="isSidebarActiveLocal">
    <div class="mt-6 flex items-center justify-between px-6">
        <h4>Change Password</h4>
        <feather-icon icon="XIcon" @click.stop="isSidebarActiveLocal = false" class="cursor-pointer"></feather-icon>
    </div>
    <vs-divider class="mb-0"></vs-divider>

    <component :is="scrollbarTag" class="scroll-area--data-list-add-new" :settings="settings" :key="$vs.rtl">

      <div class="p-6">

        <vs-input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:20'"
          name="Old Password"
          label-placeholder="Old Password"
          placeholder="Old Password"
          v-model="dataOldPassword"
          class="w-full mt-6"/>
        <span class="text-danger text-sm">{{ errors.first('Old Password') }}</span>
        <vs-input
          ref="password"
          type="password"
          data-vv-validate-on="blur"
          v-validate="'required|min:6|max:20'"
          name="password"
          label-placeholder="New Password"
          placeholder="New Password"
          v-model="dataPassword"
          class="w-full mt-6"/>
        <span class="text-danger text-sm">{{ errors.first('password') }}</span>

        <vs-input
          type="password"
          v-validate="'min:6|max:20|confirmed:password'"
          data-vv-validate-on="blur"
          data-vv-as="password"
          name="confirm_password"
          label-placeholder="New Confirm Password"
          placeholder="New Confirm Password"
          v-model="dataConfPassword"
          class="w-full mt-6"/>
        <span class="text-danger text-sm">{{ errors.first('confirm_password') }}</span>

      </div>
    </component>

    <div class="flex flex-wrap items-center p-6" slot="footer">
      <vs-button class="mr-6" @click.native="submitData" :disabled="!isFormValid">Submit</vs-button>
      <vs-button type="border" color="danger" @click.native="isSidebarActiveLocal = false">Cancel</vs-button>
    </div>
  </vs-sidebar>
</template>

<script>
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import {UPDATE_USER_PASSWORD} from '@/graphql'

export default {
  props: {
    isResetPasswordSidebarActive: {
      type: Boolean,
      required: true
    },
    data: String


  },
  components: {
    VuePerfectScrollbar
  },
  data () {
    return {
      ActiveUserID: '',
      dataOldPassword: '',
      dataPassword: '',
      dataConfPassword: '',
      settings: { // perfectscrollbar settings
        maxScrollbarLength: 60,
        wheelSpeed: .60
      }
    }
  },
  watch: {
    isResetPasswordSidebarActive (val) {
      if (!val) return
      if (Object.entries(this.data).length === 0) {
        this.initValues()
        this.$validator.reset()
      } else {

        this.ActiveUserID = localStorage.getItem('userId')
        this.dataPassword = ''
        this.dataConfPassword = ''
        this.initValues()
      }
    }
  },
  computed: {
    isSidebarActiveLocal: {
      get () {
        return this.isResetPasswordSidebarActive
      },
      set (val) {
        if (!val) {
          this.$emit('closeSidebar')
          // this.$validator.reset()
          // this.initValues()
        }
      }
    },

    isFormValid () {
      return !this.errors.any() && this.dataOldPassword && this.dataPassword && this.dataConfPassword && (this.dataPassword === this.dataConfPassword)
    },
    scrollbarTag () { return this.$store.getters.scrollbarTag }
  },
  methods: {
    initValues () {
      if (this.data.id) return
      this.dataOldPassword = ''
      this.dataPassword = ''
      this.dataConfPassword = ''
    },
    submitData () {


      if (this.ActiveUserID !== null && this.ActiveUserID >= 0) {
        this.$apollo
          .mutate({
            mutation: UPDATE_USER_PASSWORD,
            variables: {
              id: this.ActiveUserID,
              old_password: this.dataOldPassword,
              password: this.dataPassword
            }
          }).then(response => {
            if (response.data.updateUserPassword.status == 'SUCCESS') {
              this.$vs.notify({
                title: 'Password',
                text: 'Updated Sucessfully',
                color: 'success',
                position: 'top-right'
              })
              this.$emit('closeSidebar')
              this.initValues()
            } else if (response.data.updateUserPassword.status == 'NOT_MATCH') {
              this.$vs.notify({
                title: 'Old Password',
                text: 'Not Matched!',
                color: 'danger',
                position: 'top-right'
              })
            }
          })
      } else {
        this.$vs.notify({
          title: 'Invalid Data',
          text: 'Invalid input data!',
          color: 'danger',
          position: 'top-right'
        })
      }

      this.$validator.reset()

    }
  },
  created () {

    this.ActiveUserID = localStorage.getItem('userId')
  }
}
</script>

<style lang="scss" scoped>
.add-new-data-sidebar {
  ::v-deep .vs-sidebar--background {
    z-index: 52010;
  }

  ::v-deep .vs-sidebar {
    z-index: 52010;
    width: 400px;
    max-width: 90vw;

    .img-upload {
      margin-top: 2rem;

      .con-img-upload {
        padding: 0;
      }

      .con-input-upload {
        width: 100%;
        margin: 0;
      }
    }
  }
}

.scroll-area--data-list-add-new {
    // height: calc(var(--vh, 1vh) * 100 - 4.3rem);
    height: calc(var(--vh, 1vh) * 100 - 16px - 45px - 82px);

    &:not(.ps) {
      overflow-y: auto;
    }

}
</style>
